import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ChatRequest, ChatResponse } from 'src/app/core/models/ai-chat.model';
import { Header } from 'src/app/util/headerTwo';

@Injectable({
  providedIn: 'root'
})
export class AiChatService {

  private header: Header = new Header();

  constructor(private http: HttpClient) { }

  sendMessage(request: ChatRequest): Observable<ChatResponse> {
    return this.http.post<ChatResponse>(
      this.header.url.concat('ai/chat'),
      request,
      { headers: this.header.parametro }
    );
  }
}
